var React = require('react');

function Release (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#AE875C","d":"M24 16l-3-3h5.4l3 3","style":{"fill":"#AE875C"},"key":0}),React.createElement("path",{"fill":"#88653E","d":"M37.2 16.07l3-3.05h-7.8l-3 3","style":{"fill":"#88653E"},"key":1}),React.createElement("path",{"fill":"#AE875C","d":"M24 15.95h13.19v10.9H24","style":{"fill":"#AE875C"},"key":2}),React.createElement("path",{"fill":"#C09D75","d":"M24 15.95h5.4v10.9h-5.4","style":{"fill":"#C09D75"},"key":3})]));
}

Release.defaultProps = {"width":"20","height":"20","viewBox":"20.2 10.8 20 20"};

module.exports = Release;

Release.default = Release;
